import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule, Provider } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { BrandingDropdown } from './components/brand-dropdown/brand-dropdown.component';

interface ModuleOptionsInterface {
  providers: Provider[];
}

@NgModule({
  declarations: [BrandingDropdown],
  imports: [CommonModule, IonicModule, FormsModule, TranslateModule.forChild()],
  exports: [BrandingDropdown],
})
export class DynamicBrandingCoreModule {
  static forRoot(config?: ModuleOptionsInterface): ModuleWithProviders<DynamicBrandingCoreModule> {
    return {
      ngModule: DynamicBrandingCoreModule,
      providers: [...(config?.providers || [])],
    };
  }
}
